import { useLanguage } from "@/context/LanguageContext";

const FormRow = ({ children, testId }) => (
  <div className="form-row" data-testid={testId}>
    {children}
  </div>
);

const TextField = ({ type = "text", name, placeholder, value, onChange, testId, required }) => (
  <input
    type={type}
    name={name}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    data-testid={testId}
    required={required}
  />
);

const TextAreaField = ({ name, placeholder, value, onChange, testId }) => (
  <textarea
    name={name}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    data-testid={testId}
    rows="4"
  />
);

const PersonalInfoFields = ({ formData, onChange, placeholders }) => (
  <FormRow testId="contact-form-row-1">
    <TextField
      name="name"
      placeholder={placeholders.name}
      value={formData.name}
      onChange={onChange}
      testId="contact-form-name"
      required
    />
    <TextField
      name="phone"
      placeholder={placeholders.phone}
      value={formData.phone}
      onChange={onChange}
      testId="contact-form-phone"
      required
    />
  </FormRow>
);

const ProjectInfoFields = ({ formData, onChange, placeholders }) => (
  <>
    <FormRow testId="contact-form-row-2">
      <TextField
        type="email"
        name="email"
        placeholder={placeholders.email}
        value={formData.email}
        onChange={onChange}
        testId="contact-form-email"
        required
      />
      <TextField
        name="location"
        placeholder={placeholders.location}
        value={formData.location}
        onChange={onChange}
        testId="contact-form-location"
        required
      />
    </FormRow>
    <FormRow testId="contact-form-row-3">
      <TextField
        name="landSize"
        placeholder={placeholders.landSize}
        value={formData.landSize}
        onChange={onChange}
        testId="contact-form-land"
      />
      <TextField
        name="waterSource"
        placeholder={placeholders.waterSource}
        value={formData.waterSource}
        onChange={onChange}
        testId="contact-form-water"
      />
    </FormRow>
  </>
);

const MessageField = ({ formData, onChange, placeholders }) => (
  <TextAreaField
    name="message"
    placeholder={placeholders.message}
    value={formData.message}
    onChange={onChange}
    testId="contact-form-message"
  />
);

const ContactFormFields = ({ formData, onChange }) => {
  const { copy } = useLanguage();
  const placeholders = copy.contact.formPlaceholders;

  return (
    <>
      <PersonalInfoFields formData={formData} onChange={onChange} placeholders={placeholders} />
      <ProjectInfoFields formData={formData} onChange={onChange} placeholders={placeholders} />
      <MessageField formData={formData} onChange={onChange} placeholders={placeholders} />
    </>
  );
};

export default ContactFormFields;